import { render } from "./SignUpForm.vue?vue&type=template&id=4b0d5164&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=js"
export * from "./SignUpForm.vue?vue&type=script&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=4b0d5164&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4b0d5164"

export default script